import React, { Component } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import moment from "moment";
import { NumericFormat } from "react-number-format";
// import ReactTooltip from "react-tooltip";
import ReactToPrint from "react-to-print";
// require("datatables.net-buttons")();
// require("datatables.net-buttons/js/buttons.colVis.js")();

export class PortalPayments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_tag: this.props.match.params.company_tag,
      invoice_tag: this.props.match.params.invoice_tag,
      invoice_details: {
        company_image_link: "",
        company_name: "",
        company_telephone: "",
        client_name: "",
        invoice_name: "",
        invoice_due_at: "",
        invoice_total: "",
      },
      company_details: {
        company_image_link: "",
        company_name: "",
        company_telephone: "",
        client_name: "",
        invoice_name: "",
        invoice_due_at: "",
        invoice_total: "",
      },
      payment_amount: "",
      memo: "",
      memo_length: 0,
      utc_time: "",
      first_name: "",
      last_name: "",
      pay_now_disabled: false,
      forte: { card_holder_name: "", card_number: "", card_expiry_month: "", card_expiry_year: "", card_ccv: "", card_zip: "" },
    };
  }
  componentDidMount() {
    this.GetCompanyInfo();
    window.Testing = this.Testing;
    window.HandleForteSuccess = this.HandleForteSuccess;
    window.HandleForteFailure = this.HandleForteFailure;
  }

  GetCompanyInfo = () => {
    //console.log(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/portal/invoice/get");
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/portal/client/get", { company_tag: this.state.company_tag })
      .then((response) => {
        $(".splash").removeClass("active");
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({
            company_details: { ...response["data"]["data"] },
            payment_amount: 0,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        // always executed
      });
  };

  EditPayment = () => {
    $("#payment-total").hide();
    $("#payment-total-edit").show();
    $("#payment-total-edit").focus();
  };

  UpdatePayment = () => {
    $("#payment-total").show();
    $("#payment-total-edit").hide();
    if (this.state.payment_amount < 0) {
      this.setState({ payment_amount: this.props.FormatNumberTwoDecimals(this.state.payment_amount * -1) });
      return;
    }
    if (this.state.payment_amount >= 10000) {
      this.setState({ payment_amount: this.props.FormatNumberTwoDecimals(10000) }); //the 10000 cap is arbitrary, but I want some kind of safeguard to not charge millions);
      return;
    }
    this.setState({ payment_amount: this.props.FormatNumberTwoDecimals(this.state.payment_amount) });
  };
  SubmitCardTransaction = () => {
    if (this.state.first_name === "") {
      this.props.MakeNotification("warning", "Please enter a first name.");
      return;
    }
    if (this.state.last_name === "") {
      this.props.MakeNotification("warning", "Please enter a last name.");
      return;
    }
    if (this.state.payment_amount === 0) {
      this.props.MakeNotification("warning", "Please enter an amount for this payment.");
      return;
    }
    if (!this.state.forte.card_number || !this.state.forte.card_expiry_year || !this.state.forte.card_expiry_month || !this.state.forte.card_ccv || !this.state.forte.card_zip) {
      this.props.MakeNotification("warning", "Please enter all required fields for this payment.");
      return;
    }
    this.setState({ pay_now_disabled: true });
    var data = {
      api_login_id: this.state.company_details.merchant_api_login_credentials,
      card_number: this.state.forte.card_number,
      expire_year: this.state.forte.card_expiry_year,
      expire_month: this.state.forte.card_expiry_month,
      cvv: this.state.forte.card_ccv,
      zip: this.state.forte.card_zip,
    };
    window.forte.createToken(data).success(this.HandleForteSuccess).error(this.HandleForteFailure);
    return false;
  };
  HandleForteSuccess = (e) => {
    console.log("OTT Success", e);
    //expected object : {onetime_token:val}
    //this.props.MakeNotification("success", "YES");
    this.ChargeCard(e);
  };
  HandleForteFailure = (e) => {
    this.setState({ pay_now_disabled: false });
    console.log("failure");
    console.log(e);
    let responses = {
      "The browser you are using is not supported. Fortejs supports the latest versions of the following browsers: Internet Explorer, Firefox, Chrome, and Safari.":
        "The browser you are using is not supported. Fortejs supports the latest versions of the following browsers: Internet Explorer, Firefox, Chrome, and Safari.",
      "The browser you are using is not supported. Please download the latest version of your browser to use Fortejs.":
        "The browser you are using is not supported. Please download the latest version of your browser to use Fortejs.",
      "The api_login_id is required.": "Unexpected Error.",
      "The expire_month is required.": "Expiration month is required.",
      "The account_number is required.": "Account number is required.",
      "The routing_number is required.": "Routing number is required.",
      "The routing_number is invalid.": "Routing number is invalid.",
      "The account_type is required.": "Account type is required.",
      "The account_type is invalid.": "Account type is invalid.",
      "The expire_year is required.": "Expiration year is required.",
      "The cvv is required.": "CVV is required.",
      "The card_number is invalid.": "The card number is invalid.",
      "The cvv is invalid.": "The CVV is invalid.",
      "The expire_month and expire_year are invalid.": "The expiration provided is invalid.",
      "Invalid authentication.": "Unexpected error.",
    };
    if (responses[e.response_description]) {
      this.props.MakeNotification("error", responses[e.response_description]);
      return;
    }
    this.props.MakeNotification("error", "An error occurred.");
    //this.props.MakeNotification("error", "ARGH");
  };
  ChargeCard = (resp) => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/forte/c-transaction/ott", {
      company_tag: this.state.company_tag,
      ott: resp.onetime_token,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      memo: this.state.memo,
      amount: this.state.payment_amount,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
          this.setState({ pay_now_disabled: false });
        }
        if (response["data"]["status"] === "success") {
          //this.setState({pay_now_disabled: false});
          this.props.MakeNotification("success", response.data.message || "Payment initiated successfully.");
          setTimeout(() => {
            this.Testing();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        // always executed
      });
  };
  Testing = () => {
    $("#portal-invoice").animate({ left: "-=200%" }, 1000).animate({ height: "toggle", width: "toggle" }, 0);
    $("#portal-receipt").removeClass("d-none").delay(1000).animate({ opacity: "100%" }, 250);
    return;
  };
  render() {
    return (
      <div className="container">
        <div className="splash active">
          <div className="splash-icon"></div>
        </div>
        <div className="header-placeholder" style={{ height: "80px" }}></div>
        <div className="row" id="portal-invoice" style={{ position: "relative" }}>
          <div className="col-md-8 offset-md-2">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <img
                      className="card-img-top mt-3"
                      src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + this.state.company_details.company_image_link}
                      alt="Unsplash"
                      style={{ height: "auto", width: "auto", maxWidth: "50%", maxHeight: "55%" }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="mx-5">
                      <h4 className="text-muted">Payment to</h4> {this.state.company_details.company_name}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="card-body m-5 mt-0">
                <div className="row mb-3">
                  <div className="col-md-8">
                    <label className="card-title card-subtitle text-muted">Payment</label>
                    {/* <ReactTooltip /> */}
                    <h3 id="payment-total" className="clickable" data-tip="Click to Edit Amount" onClick={this.EditPayment}>
                      {this.props.FormatNumberToCurrency(this.state.payment_amount)}
                    </h3>
                    <input
                      id="payment-total-edit"
                      className="form-control"
                      style={{ display: "none" }}
                      value={this.state.payment_amount}
                      onChange={(e) => {
                        this.setState({ payment_amount: e.target.value });
                      }}
                      onBlur={this.UpdatePayment}
                    />
                  </div>
                  <div className="col-md-4 clickable" onClick={this.EditPayment}>
                    <p className="text-muted w-100 h-100 top-50 text-center position-relative">Click to edit the amount</p>
                  </div>
                </div>
                <hr></hr>
                <div className="card-header">
                  <ul className="nav nav-pills card-header-pills pull-right" role="tablist">
                    <li className="nav-item">
                      <a className="nav-link active" data-bs-toggle="tab" href="#tab-1">
                        Debit Card
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-bs-toggle="tab" href="#tab-1">
                        Credit Card
                      </a>
                    </li>
                    <li className="nav-item" data-tip="Coming Soon!">
                      <a className="nav-link disabled" data-bs-toggle="tab" href="#tab-3">
                        ACH
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  <div className="tab-content">
                    <div className="tab-pane fade active show" id="tab-1" role="tabpanel">
                      <h5 className="card-title">Debit Card</h5>
                      <div className="row mb-3">
                        <div className="col-md-6 mb-2">
                          <label htmlFor="first_name_on_card">First Name</label>
                          <input
                            type="text"
                            id="first_name_on_card"
                            name="first_name_on_card"
                            className="form-control form-control-lg"
                            value={this.state.first_name}
                            onChange={async (e) => {
                              await this.setState({ first_name: e.target.value });
                              if (this.state.first_name[0] === "%" && this.state.first_name.indexOf("=") > 0 && this.state.first_name[this.state.first_name.length - 1] === "?") {
                                let card_number = this.state.first_name.substring(2, 18);
                                let last_name = this.state.first_name.substring(this.state.first_name.indexOf("^") + 1, this.state.first_name.indexOf("^", this.state.first_name.indexOf("^") + 1));
                                let first_name = "";
                                if (last_name.indexOf("/")) {
                                  first_name = last_name.substring(last_name.indexOf("/") + 1);
                                  last_name = last_name.substring(0, last_name.indexOf("/"));
                                }
                                let expiration_month = this.state.first_name.substring(
                                  this.state.first_name.indexOf("^", this.state.first_name.indexOf("^") + 1) + 3,
                                  this.state.first_name.indexOf("^", this.state.first_name.indexOf("^") + 1) + 5,
                                );

                                let expiration_year = this.state.first_name.substring(
                                  this.state.first_name.indexOf("^", this.state.first_name.indexOf("^") + 1) + 1,
                                  this.state.first_name.indexOf("^", this.state.first_name.indexOf("^") + 1) + 3,
                                );
                                this.setState({
                                  first_name: first_name,
                                  last_name: last_name,
                                  forte: { ...this.state.forte, card_number: card_number, card_expiry_month: expiration_month, card_expiry_year: "20" + expiration_year },
                                });
                              }
                            }}
                            placeholder="John"
                          ></input>
                        </div>
                        <div className="col-md-6 mb-2">
                          <label htmlFor="last_name_on_card">Last Name</label>
                          <input
                            type="text"
                            id="last_name_on_card"
                            name="last_name_on_card"
                            className="form-control form-control-lg"
                            value={this.state.last_name}
                            onChange={(e) => {
                              this.setState({ last_name: e.target.value });
                            }}
                            placeholder="Smith"
                          ></input>
                        </div>
                        <div className="col-md-12 mb-2">
                          <label htmlFor="card_number">Card Number</label>
                          <NumericFormat
                            id="card_number"
                            className="form-control form-control-lg"
                            format="#### #### #### ####"
                            mask="-"
                            placeholder="---- ---- ---- ----"
                            value={this.state.forte.card_number}
                            onChange={(e) => {
                              this.setState((prevState) => {
                                return { ...prevState, forte: { ...prevState.forte, card_number: e.target.value.replaceAll(" ", "") } };
                              });
                            }}
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label htmlFor="card_expiry">Card Expiration</label>
                          <NumericFormat
                            id="card_expiry"
                            className="form-control form-control-lg"
                            format="##/##"
                            mask="-"
                            placeholder="MM/YY"
                            value={this.state.forte.card_expiry_month + this.state.forte.card_expiry_year.substring(2)}
                            onChange={(e) => {
                              this.setState((prevState) => {
                                return {
                                  ...prevState,
                                  forte: {
                                    ...prevState.forte,
                                    card_expiry_month: e.target.value.substr(0, Number(e.target.value.indexOf("/"))),
                                    card_expiry_year: "20" + e.target.value.substr(e.target.value.indexOf("/") + 1),
                                  },
                                };
                              });
                            }}
                          />
                        </div>
                        <div className="col-md-3 mb-2">
                          <label htmlFor="card_ccv">CCV</label>
                          <NumericFormat
                            id="card_ccv"
                            className="form-control form-control-lg"
                            format="###"
                            mask="-"
                            placeholder="---"
                            // value={this.state.forte.card_number}
                            onChange={(e) => {
                              this.setState((prevState) => {
                                return { ...prevState, forte: { ...prevState.forte, card_ccv: e.target.value } };
                              });
                            }}
                          />
                        </div>
                        <div className="col-md-5 mb-2">
                          <label htmlFor="card_zip">Zip</label>
                          <NumericFormat
                            id="card_zip"
                            className="form-control form-control-lg"
                            format="#####"
                            mask="-"
                            placeholder="-----"
                            // value={this.state.forte.card_number}
                            onChange={(e) => {
                              this.setState((prevState) => {
                                return { ...prevState, forte: { ...prevState.forte, card_zip: e.target.value } };
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 mb-2">
                        <label htmlFor="card_zip">Memo (optional)</label>
                        <textarea
                          className="form-control"
                          value={this.state.memo}
                          onChange={(e) => {
                            if (e.target.value.length <= 1000) {
                              this.setState({ memo: e.target.value, memo_length: e.target.value.length });
                            }
                          }}
                        />
                        <div className={this.state.memo_length === 1000 ? "text-right w-100 small text-danger" : "text-right w-100 small"}>{this.state.memo_length + "/1000"}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 text-right">
                          <button type="submit" className="btn btn-success btn-lg" disabled={this.state.pay_now_disabled} onClick={this.SubmitCardTransaction}>
                            {this.state.pay_now_disabled ? <FontAwesomeIcon icon="circle-notch" spin={true} /> : "Pay Now"}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="tab-3" role="tabpanel">
                      <h5 className="card-title">ACH</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* RECIEPT HERE */}
        <PortalReciept {...this.props} shared_state={this.state} />
      </div>
    );
  }
}

class PortalReciept extends Component {
  render() {
    return (
      <div className="row d-none" id="portal-receipt" style={{ opacity: "0%" }}>
        <div className="col-md-6 offset-md-3">
          <div className="row mx-auto" id="printer-selection" ref={(el) => (this.componentRef = el)}>
            <div className="col-md-12">
              <div className="card">
                <div className="card-header text-center">
                  {this.props.shared_state.company_details.company_image_link ? (
                    <img
                      className="card-img-top mt-3"
                      src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + this.props.shared_state.company_details.company_image_link}
                      alt="Unsplash"
                      style={{ height: "auto", width: "auto", maxWidth: "50%" }}
                    />
                  ) : null}
                  <h3 className="card-title mb-2">{this.props.shared_state.company_details.company_name}</h3>
                </div>
                <div className="card-body">
                  <div className="row text-center mb-3">
                    <h3>Receipt of Payment</h3>
                  </div>
                  <div className="row">
                    <hr />
                    <div className="col-md-6">
                      <p>Payee: </p>
                    </div>
                    <div className="col-md-6 text-right">
                      <p>{this.props.shared_state.first_name + " " + this.props.shared_state.last_name}</p>
                    </div>
                    <hr />
                    <div className="col-md-6">
                      <p>Date: </p>
                    </div>
                    <div className="col-md-6 text-right">
                      <p>{moment().format("MM/DD/YYYY")}</p>
                    </div>
                    <hr />
                    <div className="col-md-6">
                      <p>Amount: </p>
                    </div>
                    <div className="col-md-6 text-right">
                      <p>{this.props.FormatNumberToCurrency(this.props.shared_state.payment_amount)}</p>
                    </div>
                  </div>
                  {this.props.shared_state.memo_length > 0 ? (
                    <div className="row">
                      <hr />
                      <div className="col-md-6">
                        <p>Memo: </p>
                      </div>
                      <div className="col-md-6 text-right">
                        <p>{this.props.shared_state.memo}</p>
                      </div>
                    </div>
                  ) : null}
                  <div className="row alert-dark text-center rounded">
                    <div className="col-md-12" style={{ whiteSpace: "nowrap" }}>
                      <small>Powered by FirmTamer{"  "}</small>
                      <img
                        className="card-img"
                        src="https://firmtamer-public-bucket.s3.amazonaws.com/firmtamer-mascot-no-bg.png"
                        alt="FirmTamer Logo"
                        style={{ maxWidth: "50px", backgroundColor: "transparent" }}
                      />
                    </div>
                  </div>
                  {/* break */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <ReactToPrint
            bodyClass="row"
            trigger={() => {
              return (
                <button className="btn btn-info">
                  <FontAwesomeIcon icon="print" className="pe-none mx-2" />
                  <b>Print</b>
                </button>
              );
            }}
            content={() => this.componentRef}
          />
        </div>
      </div>
    );
  }
}

export default PortalPayments;
